import { render } from "./related_component.vue?vue&type=template&id=1c8a0d06"
import script from "./related_component.vue?vue&type=script&lang=js"
export * from "./related_component.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__